import React, { useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { toast, Toaster } from "sonner";
import { MonthYearPicker } from "../components/Filters";
import { MONTHS, formatRupiah, formatTanggal } from "../lib/format";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Badge } from "../components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { FileText, Eye, Download, Printer, Share2, CheckCircle2, XCircle, Layers, Loader2 } from "lucide-react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const sanitize = (s) => s.replace(/[.\s]+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");

function jabatan(row) {
  if (row.is_staff) return "Staff Administrasi";
  if (row.allowances.some((a) => a.type === "coordinator_allowance")) return "Guru & Coordinator GTS";
  return "Guru";
}

function SlipCard({ row, branding, year, month, forwardRef }) {
  const p = row.payment || { status: "unpaid" };
  const statusText = p.status === "paid" ? "SUDAH DIBAYAR" : "BELUM DIBAYAR";
  return (
    <div ref={forwardRef} style={{ width: 640, background: "#fff", color: "#102A56", fontFamily: "Poppins, sans-serif", padding: 32, boxSizing: "border-box" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 16, borderBottom: "3px solid #FF8A3D", paddingBottom: 16 }}>
        {branding?.logo_url && <img src={branding.logo_url} crossOrigin="anonymous" alt="" style={{ width: 56, height: 56, objectFit: "contain" }} />}
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 800, fontSize: 18, fontFamily: "Nunito, sans-serif" }}>GTS {branding?.branch || "IEC Mustikajaya"}</div>
          <div style={{ fontSize: 11, color: "#6b7280" }}>{branding?.app_name || "GTS Attendance and Teaching Record"}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontWeight: 700, fontSize: 15 }}>Slip Teaching Fee</div>
          <div style={{ fontSize: 12, color: "#FF8A3D", fontWeight: 600 }}>{MONTHS[month - 1]} {year}</div>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 16, fontSize: 13 }}>
        <div>
          <div style={{ color: "#6b7280", fontSize: 11 }}>Nama Penerima</div>
          <div style={{ fontWeight: 700, fontSize: 15 }}>{row.teacher_name}</div>
          <div style={{ color: "#6b7280", fontSize: 12 }}>{jabatan(row)}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <span style={{ background: p.status === "paid" ? "#dcfce7" : "#fee2e2", color: p.status === "paid" ? "#15803d" : "#b91c1c", padding: "4px 12px", borderRadius: 999, fontSize: 11, fontWeight: 700 }}>{statusText}</span>
        </div>
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 16, fontSize: 12 }}>
        <thead>
          <tr style={{ background: "#102A56", color: "#fff" }}>
            <th style={{ textAlign: "left", padding: "8px 10px" }}>Komponen</th>
            <th style={{ textAlign: "right", padding: "8px 10px" }}>Jumlah Sesi</th>
            <th style={{ textAlign: "right", padding: "8px 10px" }}>Tarif</th>
            <th style={{ textAlign: "right", padding: "8px 10px" }}>Subtotal</th>
          </tr>
        </thead>
        <tbody>
          {row.schools.map((s) => (
            <tr key={s.school_id} style={{ borderBottom: "1px solid #eee" }}>
              <td style={{ padding: "7px 10px" }}>{s.school_name}</td>
              <td style={{ textAlign: "right", padding: "7px 10px" }}>{s.sessions}</td>
              <td style={{ textAlign: "right", padding: "7px 10px" }}>{formatRupiah(s.rate)}</td>
              <td style={{ textAlign: "right", padding: "7px 10px" }}>{formatRupiah(s.subtotal)}</td>
            </tr>
          ))}
          {row.allowances.map((a, i) => (
            <tr key={`a${i}`} style={{ borderBottom: "1px solid #eee" }}>
              <td style={{ padding: "7px 10px" }}>{a.label}</td>
              <td style={{ textAlign: "right", padding: "7px 10px" }}>–</td>
              <td style={{ textAlign: "right", padding: "7px 10px" }}>–</td>
              <td style={{ textAlign: "right", padding: "7px 10px" }}>{formatRupiah(a.amount)}</td>
            </tr>
          ))}
          {row.others.map((o) => (
            <tr key={o.id} style={{ borderBottom: "1px solid #eee" }}>
              <td style={{ padding: "7px 10px" }}>Lain-lain: {o.description}</td>
              <td style={{ textAlign: "right", padding: "7px 10px" }}>–</td>
              <td style={{ textAlign: "right", padding: "7px 10px" }}>–</td>
              <td style={{ textAlign: "right", padding: "7px 10px", color: o.amount < 0 ? "#b91c1c" : "inherit" }}>{formatRupiah(o.amount)}</td>
            </tr>
          ))}
          <tr style={{ background: "#FFF3E8", fontWeight: 800 }}>
            <td style={{ padding: "10px" }} colSpan={3}>Total Dibayarkan</td>
            <td style={{ textAlign: "right", padding: "10px", color: "#FF8A3D" }}>{formatRupiah(row.total)}</td>
          </tr>
        </tbody>
      </table>

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 14, fontSize: 11, color: "#374151" }}>
        <div>
          {p.status === "paid" && (
            <>
              <div>Tanggal Pembayaran: {p.paid_date ? formatTanggal(p.paid_date) : "-"}</div>
              <div>Metode: {p.method || "-"}</div>
              {p.reference && <div>No. Referensi: {p.reference}</div>}
            </>
          )}
          {p.note && <div>Catatan: {p.note}</div>}
        </div>
        <div style={{ textAlign: "center", marginTop: 8 }}>
          <div style={{ fontSize: 11 }}>Branch Manager</div>
          <div style={{ height: 44 }} />
          <div style={{ borderTop: "1px solid #102A56", paddingTop: 4, fontWeight: 600 }}>Abdulloh</div>
        </div>
      </div>

      <div style={{ marginTop: 16, fontSize: 10, color: "#9ca3af", textAlign: "center", borderTop: "1px dashed #e5e7eb", paddingTop: 8 }}>
        Dokumen ini dibuat secara elektronik oleh GTS IEC Mustikajaya.
      </div>
    </div>
  );
}

export default function SlipGaji() {
  const [year, setYear] = useState(2026);
  const [month, setMonth] = useState(8);
  const [data, setData] = useState(null);
  const [branding, setBranding] = useState({});
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  const [payDialog, setPayDialog] = useState(null);
  const [payForm, setPayForm] = useState({ paid_date: "", method: "Transfer", reference: "", note: "" });
  const nodeRefs = useRef({});
  const previewRef = useRef(null);

  const load = () => {
    setLoading(true);
    api.get(`/salary-slips?year=${year}&month=${month}`).then((r) => setData(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, [year, month]);
  useEffect(() => { api.get("/settings/branding").then((r) => setBranding(r.data)).catch(() => {}); }, []);

  const captureToCanvas = async (node) => {
    return html2canvas(node, { scale: 2, useCORS: true, backgroundColor: "#ffffff", logging: false });
  };

  const addCanvasToPdf = (pdf, canvas, firstPage) => {
    const pageW = pdf.internal.pageSize.getWidth();
    const margin = 10;
    const imgW = pageW - margin * 2;
    const imgH = (canvas.height * imgW) / canvas.width;
    if (!firstPage) pdf.addPage();
    pdf.addImage(canvas.toDataURL("image/png"), "PNG", margin, margin, imgW, imgH);
  };

  const downloadOne = async (row) => {
    const node = nodeRefs.current[row.teacher_id];
    if (!node) return;
    setBusy(true);
    try {
      const canvas = await captureToCanvas(node);
      const pdf = new jsPDF("p", "mm", "a4");
      addCanvasToPdf(pdf, canvas, true);
      pdf.save(`Slip-Gaji-${sanitize(row.teacher_name)}-${MONTHS[month - 1]}-${year}.pdf`);
      toast.success("PDF diunduh");
    } catch (e) { toast.error("Gagal membuat PDF"); }
    finally { setBusy(false); }
  };

  const printOne = async (row) => {
    const node = nodeRefs.current[row.teacher_id];
    if (!node) return;
    setBusy(true);
    try {
      const canvas = await captureToCanvas(node);
      const pdf = new jsPDF("p", "mm", "a4");
      addCanvasToPdf(pdf, canvas, true);
      pdf.autoPrint();
      const url = pdf.output("bloburl");
      window.open(url, "_blank");
    } catch (e) { toast.error("Gagal mencetak"); }
    finally { setBusy(false); }
  };

  const shareOne = async (row) => {
    const node = nodeRefs.current[row.teacher_id];
    if (!node) return;
    setBusy(true);
    try {
      const canvas = await captureToCanvas(node);
      const pdf = new jsPDF("p", "mm", "a4");
      addCanvasToPdf(pdf, canvas, true);
      const blob = pdf.output("blob");
      const file = new File([blob], `Slip-Gaji-${sanitize(row.teacher_name)}-${MONTHS[month - 1]}-${year}.pdf`, { type: "application/pdf" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: "Slip Teaching Fee" });
      } else {
        toast.info("Perangkat tidak mendukung share, mengunduh sebagai gantinya");
        pdf.save(file.name);
      }
    } catch (e) { if (e.name !== "AbortError") toast.error("Gagal membagikan"); }
    finally { setBusy(false); }
  };

  const generateAll = async () => {
    if (!data?.rows?.length) return;
    setBusy(true);
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      let first = true;
      for (const row of data.rows) {
        const node = nodeRefs.current[row.teacher_id];
        if (!node) continue;
        const canvas = await captureToCanvas(node);
        addCanvasToPdf(pdf, canvas, first);
        first = false;
      }
      pdf.save(`Slip-Gaji-Semua-${MONTHS[month - 1]}-${year}.pdf`);
      toast.success("Semua slip digabung dalam satu PDF");
    } catch (e) { toast.error("Gagal generate semua slip"); }
    finally { setBusy(false); }
  };

  const openPay = (row) => {
    const p = row.payment || {};
    setPayForm({ paid_date: p.paid_date || new Date().toISOString().slice(0, 10), method: p.method || "Transfer", reference: p.reference || "", note: p.note || "" });
    setPayDialog(row);
  };

  const markPaid = async () => {
    try {
      await api.post("/salary-slips/status", { teacher_id: payDialog.teacher_id, year, month, status: "paid", ...payForm });
      toast.success("Ditandai sudah dibayar"); setPayDialog(null); load();
    } catch (e) { toast.error("Gagal"); }
  };

  const cancelPaid = async (row) => {
    try {
      await api.post("/salary-slips/status", { teacher_id: row.teacher_id, year, month, status: "unpaid" });
      toast.success("Status pembayaran dibatalkan"); load();
    } catch (e) { toast.error("Gagal"); }
  };

  return (
    <div className="space-y-5" data-testid="slip-page">
      <Toaster position="top-center" richColors />
      <div className="flex flex-col sm:flex-row justify-between gap-3">
        <div>
          <h2 className="font-nunito font-extrabold text-2xl text-gtsnavy">Slip Gaji</h2>
          <p className="text-sm text-muted-foreground">Slip Teaching Fee · {MONTHS[month - 1]} {year}</p>
        </div>
        <div className="flex gap-2">
          <MonthYearPicker year={year} month={month} setYear={setYear} setMonth={setMonth} />
          <Button onClick={generateAll} disabled={busy || !data?.rows?.length} className="rounded-full bg-gtsnavy text-white gap-1" data-testid="generate-all-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Layers className="w-4 h-4" />} Generate Semua
          </Button>
        </div>
      </div>

      {loading ? (
        <div className="p-16 flex justify-center"><Loader2 className="w-7 h-7 text-gtsorange animate-spin" /></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {data?.rows.map((row) => {
            const paid = row.payment?.status === "paid";
            return (
              <Card key={row.teacher_id} className="rounded-2xl border-none shadow-[0_8px_30px_rgb(16,42,86,0.06)] p-5 bg-white" data-testid={`slip-card-${row.teacher_id}`}>
                <div className="flex items-start gap-3">
                  <div className="w-11 h-11 rounded-2xl bg-gtsorange/15 flex items-center justify-center shrink-0"><FileText className="w-5 h-5 text-gtsorange" /></div>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-gtsnavy truncate">{row.teacher_name}</p>
                    <p className="text-xs text-muted-foreground">{jabatan(row)}</p>
                  </div>
                  <Badge className={`rounded-full ${paid ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700"}`} data-testid={`slip-status-${row.teacher_id}`}>
                    {paid ? "Sudah Dibayar" : "Belum Dibayar"}
                  </Badge>
                </div>
                <p className="font-nunito font-extrabold text-2xl text-gtsorange mt-3">{formatRupiah(row.total)}</p>
                <div className="flex flex-wrap gap-2 mt-4">
                  <Button size="sm" variant="outline" onClick={() => setPreview(row)} className="rounded-full gap-1" data-testid={`preview-${row.teacher_id}`}><Eye className="w-3.5 h-3.5" /> Preview</Button>
                  <Button size="sm" variant="outline" onClick={() => downloadOne(row)} disabled={busy} className="rounded-full gap-1" data-testid={`download-${row.teacher_id}`}><Download className="w-3.5 h-3.5" /> PDF</Button>
                  <Button size="sm" variant="outline" onClick={() => printOne(row)} disabled={busy} className="rounded-full gap-1" data-testid={`print-${row.teacher_id}`}><Printer className="w-3.5 h-3.5" /></Button>
                  <Button size="sm" variant="outline" onClick={() => shareOne(row)} disabled={busy} className="rounded-full gap-1" data-testid={`share-${row.teacher_id}`}><Share2 className="w-3.5 h-3.5" /></Button>
                  {paid ? (
                    <Button size="sm" variant="outline" onClick={() => cancelPaid(row)} className="rounded-full gap-1 text-rose-600 border-rose-200" data-testid={`cancel-paid-${row.teacher_id}`}><XCircle className="w-3.5 h-3.5" /> Batalkan</Button>
                  ) : (
                    <Button size="sm" onClick={() => openPay(row)} className="rounded-full gap-1 bg-emerald-500 hover:bg-emerald-600 text-white" data-testid={`mark-paid-${row.teacher_id}`}><CheckCircle2 className="w-3.5 h-3.5" /> Tandai Dibayar</Button>
                  )}
                </div>
              </Card>
            );
          })}
        </div>
      )}

      {/* Off-screen slips for capture */}
      <div style={{ position: "fixed", left: -10000, top: 0 }} aria-hidden>
        {data?.rows.map((row) => (
          <SlipCard key={row.teacher_id} row={row} branding={branding} year={year} month={month} forwardRef={(el) => (nodeRefs.current[row.teacher_id] = el)} />
        ))}
      </div>

      {/* Preview */}
      <Dialog open={!!preview} onOpenChange={(o) => !o && setPreview(null)}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-auto gts-scroll">
          <DialogHeader><DialogTitle>Preview Slip</DialogTitle></DialogHeader>
          {preview && (
            <div className="overflow-x-auto">
              <SlipCard row={preview} branding={branding} year={year} month={month} forwardRef={previewRef} />
            </div>
          )}
          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => downloadOne(preview)} disabled={busy} className="rounded-full gap-1"><Download className="w-4 h-4" /> Download PDF</Button>
            <Button onClick={() => printOne(preview)} disabled={busy} className="rounded-full bg-gtsnavy text-white gap-1"><Printer className="w-4 h-4" /> Print</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Mark paid dialog */}
      <Dialog open={!!payDialog} onOpenChange={(o) => !o && setPayDialog(null)}>
        <DialogContent>
          <DialogHeader><DialogTitle>Tandai Sudah Dibayar · {payDialog?.teacher_name}</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Tanggal Pembayaran</Label><Input type="date" value={payForm.paid_date} onChange={(e) => setPayForm({ ...payForm, paid_date: e.target.value })} className="rounded-xl mt-1" data-testid="pay-date" /></div>
            <div>
              <Label>Metode Pembayaran</Label>
              <Select value={payForm.method} onValueChange={(v) => setPayForm({ ...payForm, method: v })}>
                <SelectTrigger className="rounded-xl mt-1" data-testid="pay-method"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="Transfer">Transfer</SelectItem>
                  <SelectItem value="Tunai">Tunai</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div><Label>No. Referensi (opsional)</Label><Input value={payForm.reference} onChange={(e) => setPayForm({ ...payForm, reference: e.target.value })} className="rounded-xl mt-1" data-testid="pay-ref" /></div>
            <div><Label>Catatan (opsional)</Label><Input value={payForm.note} onChange={(e) => setPayForm({ ...payForm, note: e.target.value })} className="rounded-xl mt-1" data-testid="pay-note" /></div>
          </div>
          <DialogFooter><Button onClick={markPaid} className="rounded-full bg-emerald-500 hover:bg-emerald-600 text-white" data-testid="confirm-paid">Simpan</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
